import styles from "./select.module.css"
import React from "react";
import {useEffect, useRef, useState} from "react";

export default function Select({name, children, filterId, onSelectionChanged}){
    const ref = useRef()
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [title, setTitle] = useState(name)

    function setName(key, newValue){
        setTitle(newValue);
        let filterValue = "filter_"+newValue.toLowerCase().replaceAll(" ", "_");
        if(key == 0) filterValue = "";
        onSelectionChanged(filterValue, filterId)
        setIsMenuOpen(false);
    }

    const childrenWithProps = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { setName });
        }
        return child;
    });


    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                setIsMenuOpen(false);
            }
        }

        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [isMenuOpen])
    return(
        <div className={styles.outer} ref={ref}>
            <div className="horizontal mobile" style={{cursor:"pointer", alignItems:"center"}} onClick={() => {setIsMenuOpen(!isMenuOpen)}}>
                <p className="annotation uppercase">{title}</p>
                <svg style={{width:"30px",height:"24px", marginLeft:0}} viewBox="0 0 24 24">
                    <path fill="currentColor" d="M7,10L12,15L17,10H7Z" />
                </svg>
            </div>
            {isMenuOpen && <div id={`options_${name}`} className={styles.options}>
                {childrenWithProps}
            </div>}
        </div>
    );
}
